import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import {defaultTableChange1} from "../../../../../modules/custom/customTable";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import {inputConfig} from "../config/config";
import InventoryInputs from "./inventoryInputs";
import Api from "../../../../../Services/Api";
import {contructQueryParam, fetchDataAsync} from "../../../../../Services/Utils";
import withFormGroup from "../../../../../modules/commons/withFormGroup";
import {ACTIVITY_TYPE, HttpStatus} from "../../../../common/Constants";
import {mapToObjectDDL} from "../../../../common/mapper";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";
import {constructDataDetailUnitKSU, constructToQRReportKSU, validateDataDetailUnitKSU} from "../util";
import InventoryPreviewQR from "./inventoryPreviewQR";
import {v4 as uuidv4} from "uuid";
import {ta} from "date-fns/esm/locale";
import moment from "moment";

class InventoryDetail extends Component {
    constructor(props) {
        super(props);
        this.initialData = {
            kodeKSU: null,
            namaKSU: null,
            kategori: null,
            jumlah: null,
            kodeLocation: null,
            qrCode: null,
            numbersOfPrint: null,
            saved: false
        };
        this.inputConfig = inputConfig[props.tab];
        this.currentDate = moment(new Date()).format("DD-MM-YYYY");
        this.withQrTableOptions = {
            selectableRows: "multiple",
            ...defaultTableChange1(
                this.handleChangePage,
                this.handleRowsPerPage,
                this.handleOnRowSelected
            ),
        };
        this.state = {
            loading: false,
            activityRead: true,
            warningModalVisible: false,
            submitCorrectionModalVisible: false,
            previewQrVisible: false,
            deleteModalVisible: false,
            tableConfig: this.props.tableConfig.table.firstPanelConfig,
            tableOptions: null,
            PDF: null,
            savedDataHeader: null,
            dataDetail: null,
            selectedDataQR: [],
            dataTableWithQr: !R.isNil(this.props.qrData) ? this.props.qrData : [],
            dataTableNoQr: !R.isNil(this.props.noQrData) ? this.props.noQrData : [],
            dataTable: [],
            dataSupplier: [],
            dataSupplierExpedition: [],
            dataKSU: [],
            isCanDelete: true,
            rawListDetailKSU: [],
            dataDetailSaved: [],
            inventoryDetailOrigin:null,
            warningAlert:{
                visible:false,
                title:null,
                content: null
            },
            popupApproval: {
                data: [],
                visible: false,
                isConfirmation: false,
                barcodeNeedApproval: []
            },
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            }
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        this.props.setValue("kodeCabang", this.props.selectedCabang)
        if (R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE)) {
            let res = await this.fetchDataDetail(contructQueryParam({
                spbkNo: this.props.initialValues.noSpbk,
            }));

            if (res.ok) {
                this.props.setValue("spbkNo", res.data.data?.receivingKsuResponseDTO?.spbkNo);
                this.props.setValue("spbkDate", res.data.data?.receivingKsuResponseDTO?.spbkDate);
                this.props.setValue("spbmNo", res.data.data?.receivingKsuResponseDTO?.spbmNo);
                this.props.setValue("spbmDate", res.data.data?.receivingKsuResponseDTO?.spbmDate);
                this.props.setValue("slNo", res.data.data?.receivingKsuResponseDTO?.slNo);
                this.props.setValue("slDate", res.data.data?.receivingKsuResponseDTO?.slDate);
                this.props.setValue("noPolKendaraan", res.data.data?.receivingKsuResponseDTO?.noPolKendaraan);
                this.props.setValue("note", res.data.data?.receivingKsuResponseDTO?.note);
                this.props.setValue("total", res.data.data?.receivingKsuResponseDTO?.total);
                let supplier = res.data.data?.receivingKsuResponseDTO?.supplierDto;
                this.props.setValue(
                    "idSupplier",
                    supplier ? mapToObjectDDL(supplier.supplierName, supplier.supplierCode) : null
                );
                let supplierExp = res.data.data?.receivingKsuResponseDTO?.expedisiDto;
                this.props.setValue(
                    "idSupplierExpedisi",
                    supplierExp ? {
                        value: supplierExp.supplierCode,
                        label: supplierExp.supplierCode,
                        name: supplierExp.supplierName
                    } : null
                );
                let dataDetail = res.data.data?.receivingKsuBarcodeResponseDTOList.map(item => {
                    return {
                        ...item,
                        kodeKSU: mapToObjectDDL(
                            item.masterKSU?.kodeKSU,
                            item.masterKSU?.kodeKSU,
                        ),
                        namaKSU: item.masterKSU?.name,
                        kategori: item.masterKSU?.categoryDTO?.value,
                        qrCode: item.ksuBarcode,
                        qrCodeEncrypted: item.ksuBarcodeEncrypted,
                        jumlah: 1,
                        numbersOfPrint: item.numbersOfPrint,
                        kodeLocation: item.locationDTO ? mapToObjectDDL(
                            item.locationDTO?.nameLocation,
                            item.locationDTO?.kodeLocation,
                        ) : null,
                        saved: true
                    }
                });
                const inventoryDetailOrigin = {
                    spbkDate: res.data.data?.receivingKsuResponseDTO?.spbkDate,
                    spbmNo: res.data.data?.receivingKsuResponseDTO?.spbmNo,
                    noPolKendaraan: res.data.data?.receivingKsuResponseDTO?.noPolKendaraan,
                    idSupplierExpedisi: res.data.data?.receivingKsuResponseDTO?.expedisiDto?.supplierCode,
                    note: res.data.data?.receivingKsuResponseDTO?.note
                }
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataTable: dataDetail,
                    dataDetailRollBack: dataDetail,
                    isCanDelete: res.data.data?.checkDelete,
                    inventoryDetailOrigin,
                    pagination:{
                        ...prevValue.pagination,
                        totalData: dataDetail?.length || 0
                    }
                }));
            }
        }
        await this.fetchDataSupplierExpedition();
        this.fetchDataKSU();
        this.fetchDataLocator();
        this.handleTriggerLoading();
    }

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevState.activityRead !== this.state.activityRead) {
            this.handleTriggerLoading();
            this.setState((prevValue) => ({
                ...prevValue,
                tableConfig: prevValue.activityRead
                    ? this.props.tableConfig.table.firstPanelConfig
                    : this.props.tableConfig.table.secondPanelConfig(
                        this.state.dataKSU,
                        this.state.dataLocator,
                        this.state.dataTable,
                        this.handleSelectCodeKSU,
                        this.handleValueChange,
                        this.handleMultipleLocatorChange,
                        this.handleSingleLocatorChange,
                        this.handleSaveRow,
                        this.handleEditRow,
                        this.handleDeleteRow,
                    ),
            }));

            if (R.isEmpty(this.state.dataKSU)) {
                await this.fetchDataKSU();
            }
            this.handleTriggerLoading();
        }
    }

    handleCorrection = async (action) => {
        this.handleTriggerLoading();
        if (R.equals(action, "cancel_correction")) {
            if (!R.isNil(this.state.savedDataHeader)) {
                this.props.setValue("spbkDate", this.state.savedDataHeader.spbkDate.value);
                this.props.setValue("noPolKendaraan", this.state.savedDataHeader.noPolKendaraan.value);
                this.props.setValue("idSupplierExpedisi", this.state.savedDataHeader.idSupplierExpedisi.value);
            }

            this.setState((prevState) => ({
                ...prevState,
                activityRead: !prevState.activityRead,
                dataTable: prevState.dataDetailRollBack,
                dataDetailSaved: [],
            }))
        } else {
            let res = await this.fetchDataDetailCorrection(contructQueryParam({
                spbkNo: this.props.initialValues.noSpbk,
            }))

            if (res.ok) {
                let dataDetail = res.data.data?.listDetaiKsu.map(item => {
                    return {
                        ...item,
                        kodeKSU: mapToObjectDDL(
                            item.masterKSU?.kodeKSU,
                            item.masterKSU?.kodeKSU,
                        ),
                        namaKSU: item.masterKSU?.name,
                        kategori: item.masterKSU?.categoryDTO?.value,
                        jumlah: item.total,
                        kodeLocation: item.masterLocation ? mapToObjectDDL(
                            item.masterLocation?.nameLocation,
                            item.masterLocation?.kodeLocation,
                        ) : null,
                        saved: true
                    }
                });

                this.setState((prevValue) => ({
                    ...prevValue,
                    activityRead: !prevValue.activityRead,
                    dataTable: dataDetail,
                    dataDetailSaved: dataDetail,
                    rawListDetailKSU: dataDetail,
                }));
            }
        }
        this.handleTriggerLoading();
    }

    handlePopupAlertVisibility = (data, barcodeNeedApproval) => {
        this.setState(prev=>({
            popupApproval: {
              data: data || [],
              visible: !prev.popupApproval.visible,
              isConfirmation: Boolean(barcodeNeedApproval),
              barcodeNeedApproval: barcodeNeedApproval || []
            },
        }));
    }

    validateQRCodePrintApproval = async () => {
        const userId = localStorage.getItem("userId");
        const { selectedDataQR } = this.state;
        const { controls, selectedCabang } = this.props;    
        const payload = {
          trxId: controls.spbkNo.value,
          kodeCabang: selectedCabang?.value,
          idUserPemohon: userId,
          module: "RECEIVING_KSU",
          listBarcode: selectedDataQR?.map(item => item.ksuBarcode),
        };
        const response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").checkPrintQRKSUApproval,
            menuName: "Receiving Unit - KSU",
            setError: this.props.setError,
            args: payload
        })
        console.log(response,'response')
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
          const { listBarcodeToPrint, listBarcodeNeedApproval, listIdRequest } = response.data.data;    
          if (listBarcodeToPrint) {
            await this.fetchGenerateQRCode();
          } else {
            this.handlePopupAlertVisibility(listBarcodeNeedApproval || listIdRequest, listBarcodeNeedApproval)
          }
        }else{
            throw new Error(response.data.message)
        }
    };

    createApprovalQRPrint = async () =>{
        const { popupApproval } = this.state;
        const { controls, selectedCabang } = this.props;
        const userId = localStorage.getItem("userId");

        this.handleTriggerLoading()

        const payload = {
            trxId: controls.spbkNo.value,
            kodeCabang: selectedCabang?.value,
            idUserPemohon: userId,
            module: "RECEIVING_KSU",
            listBarcode: popupApproval.barcodeNeedApproval || [],
        };
        const res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").createApprovalPrint,
            menuName: "Receiving KSU",
            setError: this.props.setError,
            args: payload,
        })
        this.handleTriggerLoading()
        if(res.ok && res.data.status === HttpStatus.SUCCESS){
            this.handlePreviewQrVisibility("close")
            this.handlePopupAlertVisibility()
        }
    }


    handlePreviewQrVisibility = async (action) => {
        this.handleTriggerLoading();
        if (R.equals(action, "generate")) {
            if(!this.state.selectedDataQR || this.state.selectedDataQR.length === 0){
                this.handleTriggerLoading();
                return this.handleWarningAlertVisibility("PERINGATAN","Data belum di ceklis, harap pilih data terlebih dahulu untuk dicetak.")
            }
            await this.validateQRCodePrintApproval();
        }

        if (R.equals(action, "close")) {
            await this.componentDidMount();
            this.setState((prevValue) => ({
                ...prevValue,
                selectedDataQR: [],
                previewQrVisible: false,
            }));
        }
        this.handleTriggerLoading();
    };

    handleWarningModalVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            warningModalVisible: !prevState.warningModalVisible,
        }))
    }

    handleSubmitCorrectionModalVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            submitCorrectionModalVisible: !prevState.submitCorrectionModalVisible,
        }))
    }

    handleModalDeleteVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            deleteModalVisible: !prevState.deleteModalVisible,
        }));
    };

    handleClear = () => {
        this.props.resetIgnoreKeys(["spbkNo", "idSupplier", "kodeCabang"]);
        this.props.setValue("spbkDate", this.currentDate);
        this.setState((prevState) => ({
            ...prevState,
            dataTable: [],
            dataDetailSaved: [],
        }));
    };

    handleAddRow = () => {
        try {
            const newUnit = {
                ...this.initialData,
                id: uuidv4(),
            };

            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: [...prevValue.dataTable, newUnit],
                dataDetailSaved: [...prevValue.dataDetailSaved, newUnit],
            }));
        } catch (error) {
            console.log("errors: ", error);
        }
    };

    handleEditRow = (index) => {
        this.setState((prevValue) => {
            const newState = [...prevValue.dataTable];
            newState[index] = {
                ...newState[index],
                saved: !newState[index].saved,
            };

            return {
                ...prevValue,
                dataTable: newState,
            };
        });
    };

    handleSaveRow = (index) => {
        this.setState((prevValue) => {
            const newState = [...prevValue.dataTable];
            newState[index] = {
                ...newState[index],
                saved: !newState[index].saved,
            };

            return {
                ...prevValue,
                dataTable: newState,
                dataDetailSaved: newState,
            };
        });
    };

    handleDeleteRow = (index) => {
        this.setState((prevValue) => ({
            ...prevValue,
            dataTable: [...prevValue.dataTable.filter((_, idx) => idx !== index)],
            dataDetailSaved: [...prevValue.dataDetailSaved.filter((_, idx) => idx !== index)],
        }));
    };

    handleSelectCodeKSU = (index, name, value) => {
        if (!R.isEmpty(this.state.dataKSU)) {
            let ksu = this.state.dataKSU.find(item => item.kodeKSU === value?.value);
            this.setState((prevValue) => {
                const newState = [...prevValue.dataTable];
                newState[index] = {
                    ...newState[index],
                    [name]: value,
                    namaKSU: ksu?.name,
                    kategori: ksu?.categoryDTO?.value,
                };

                return {
                    ...prevValue,
                    dataTable: newState,
                };
            });
        }
    };

    handleValueChange = (index, colName, value) => {
        this.setState((prevState) => {
            const newState = [...prevState.dataTable];
            newState[index] = {
                ...newState[index],
                [colName]: value,
            };
            return {
                ...prevState,
                dataTable: newState,
            };
        });
    };

    handleStateChange = (callback) => {
        this.setState(callback);
    };

    handleSingleLocatorChange = (index, value) => {
        this.setState((prevValue) => {
            const newState = [...prevValue.dataTable];
            newState[index] = {
                ...newState[index],
                kodeLocation: value,
            };
            return {
                ...prevValue,
                dataTable: newState,
            };
        });
    };

    handleMultipleLocatorChange = (value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            dataTable: prevValue.dataTable.map((data) => ({
                ...data,
                locator: !data.saved ? value : data.locator,
            })),
        }));
    };

    handleOnRowSelected = (listIndex) => {
        const selectedData = listIndex.map(index => this.state.dataTable[index]);
        this.setState((prevState) => ({
            ...prevState,
            selectedDataQR: selectedData,
        }))
    }

    getCompareInventoryDetail = (data) => {
      console.log(data);
      const { spbkDate, spbmNo, noPolKendaraan, idSupplierExpedisi, note } =
        data;
      return {
        spbkDate: spbkDate.value || spbkDate,
        spbmNo: spbmNo.value || spbmNo,
        noPolKendaraan: noPolKendaraan.value || noPolKendaraan,
        idSupplierExpedisi: idSupplierExpedisi.value || idSupplierExpedisi,
        note: note.value || note,
      };
    }

    getCompareUnitPayload = (data) => {
        return data?.map((item) => {
            const {kodeLocation, kodeKSU, jumlah} = item;
            return {kodeLocation, kodeKSU, jumlah};
        });
    }

    checkIsListUnitKSUChange = (origin, modified) => {
        const originPayload = this.getCompareUnitPayload(origin)
        const modifiedPayload = this.getCompareUnitPayload(modified);
        return JSON.stringify(originPayload) !== JSON.stringify(modifiedPayload)
    }

    compareInventoryDetail = (origin,modified) =>{
        const originInventory = this.getCompareInventoryDetail(origin)
        const modifiedInventory = this.getCompareInventoryDetail(modified)
        console.log(originInventory)
        console.log(modifiedInventory)
        return JSON.stringify(originInventory) !== modifiedInventory;
    }

    handleSubmitCheck = () => {
        if (
          !this.props.validate() ||
          !validateDataDetailUnitKSU(this.state.dataDetailSaved)
        ) {
          this.handleWarningModalVisibility();
        } else if (
          this.checkIsListUnitKSUChange(
            this.state.rawListDetailKSU,
            this.state.dataDetailSaved
          )
          //   this.compareInventoryDetail(
          //     this.state.inventoryDetailOrigin,
          //     this.props.controls
          //   )
        ) {
          this.handleSubmitCorrectionModalVisibility();
        } else {
          this.handleSubmit(true)
        }
    }

    handleSubmit = (hideConfirmation) => {
        let details = constructDataDetailUnitKSU(this.state.dataDetailSaved);
        if(!hideConfirmation){
            this.handleSubmitCorrectionModalVisibility();
        }
        this.props.onSubmit("updated", this.props.controls, details)
    }

    handleSubmitDelete = () => {
        this.props.onDelete(this.props.controls.spbkNo.value);
        this.handleModalDeleteVisibility();
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchDataDetail = async (requestParam) => {
        try {
            return await Api.create("NAGAMAS_TRANSACTION").getDetailBarcodeReceivingKSU(requestParam);
        } catch (error) {
            console.log("errors: ", error);
        }
    };

    fetchDataSupplierExpedition = async () => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSupplierExpedition,
            menuName: "Receiving Unit - DGI",
            setError: this.props.setError,
            args: contructQueryParam({kodeCabang: this.props.selectedCabang.value}),
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                dataSupplierExpedition: res.data.data,
            }));
        }
    }

    fetchDataKSU = async () => {
        try {
            let response = await Api.create("NAGAMAS_MASTER_DATA").getAllKSUPagingByParam({
                paramFilters: {}, limit: null, page: null
            });
            if (response.ok) {
                this.setState((prevState) => ({
                    ...prevState,
                    dataKSU: response.data.data,
                }));
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    fetchDataLocator = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").getAllMasterLocationPagingByParam({
                paramFilters: {kodeCabang: this.props.selectedCabang?.value},
                page: null,
                limit: null
            })

            if (res.ok) {
                this.setState((prevState) => ({
                    ...prevState,
                    dataLocator: res.data.data
                }));
            }

        } catch (error) {
            console.log("errors: ", error);
        }
    }

    fetchGenerateQRCode = async () => {
        try {
            let reqBody = constructToQRReportKSU(this.state.selectedDataQR)
            let res = await Api.create("NAGAMAS_REPORT").generateQRReceivingUnitKSU(reqBody)
            if (res.ok) {
                if (reqBody.length > 0) {
                    await this.fetchUpdateNumberOfPrintQRCode();
                this.setState((prevState) => ({
                    ...prevState,
                    previewQrVisible: true,
                    PDF: URL.createObjectURL(res.data)
                }));
                }
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    fetchUpdateNumberOfPrintQRCode = async () => {
        try {
            let reqBody = this.state.selectedDataQR.map(item => item.qrCode);
            await Api.create("NAGAMAS_TRANSACTION").updateNumberOfPrintQRCodeKSU(reqBody)
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    fetchDataDetailCorrection = async (requestParam) => {
        try {
            return await Api.create("NAGAMAS_TRANSACTION").getDetailReceivingKSU(requestParam)
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    handleWarningAlertVisibility = (title = null, content=null) =>{
        this.setState({
            warningAlert: {
                visible: !!title,
                title,
                content
            }
        })
    }

    renderAlertApproval = () =>{
        const { popupApproval } = this.state;
        const isConfirmation = popupApproval.isConfirmation;
        const title = isConfirmation ? "Konfirmasi" : "Informasi";
        const subTitle = isConfirmation ? "Cetak ulang QR dengan no QR:" : "Pengajuan tidak dapat dilakukan sebelum pengajuan dengan No. Request: " 
        const desc = isConfirmation ? "Apakah anda yakin?" : "dilakukan keputusan APPROVE/REJECT"
        if(!popupApproval.visible){
            return null
        }
        return (
            <SimpleAlert
              title={title}
              visible={popupApproval.visible}
              onClickClose={() => this.handlePopupAlertVisibility()}
              content={
                <div style={{textAlign:'left'}}>
                    <p style={{marginBottom:'10px'}}>{subTitle}</p>
                    <FlexView style={{gap:'10px', maxHeight: "200px", overflowY: "auto"}}>
                         <ul
                          style={{
                            listStyleType: 'circle',
                            paddingLeft: '20px'
                          }}
                        >
                            {popupApproval?.data.map(item=> <li key={item}>{item}</li>)}
                        </ul>
                    </FlexView>
                    <p style={{marginTop:'10px'}}>{desc}</p>
                </div>
              }
              additionalButtons={
                isConfirmation ? (
                  <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                    <SimpleButton onClick={() => this.handlePopupAlertVisibility()}>
                      TIDAK
                    </SimpleButton>
                    <SimpleButton onClick={this.createApprovalQRPrint}>
                      YA
                    </SimpleButton>
                  </FlexView>
                ) : (
                  <SimpleButton onClick={() => this.handlePopupAlertVisibility()}>
                    OK
                  </SimpleButton>
                )
              }
            />
        )
    }

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        return (
            <>
                <SimpleModal
                    title="Detail Penerimaan KSU"
                    visible={this.props.visible}
                    onClickClose={() => this.props.onClickClose()}
                    content={
                        <ModalContainer>
                            <InventoryInputs
                                {...this.props}
                                inputConfig={this.inputConfig}
                                activityRead={this.state.activityRead}
                                dataSupplier={this.state.dataSupplier}
                                dataSupplierExpedition={this.state.dataSupplierExpedition}
                            />
                            {
                                this.state.activityRead ?
                                    <FlexView vAlignContent="center" style={{justifyContent: "space-between"}}>
                                        <h3 className="margin-bottom-10px">Detail Penerimaan :</h3>
                                        <h4 className="margin-bottom-10px">Jumlah
                                            Data: {this.state.dataTable?.length}</h4>
                                    </FlexView>
                                    :
                                    <FlexView vAlignContent="center" className="margin-bottom-10px">
                                        <h4 className="margin-right-10px">UNIT KSU</h4>
                                        <SimpleButton
                                            className={"btn btn-plus background-red margin-left-10px"}
                                            onClick={this.handleAddRow}
                                            icon={<i className="fa fa-plus margin-right-10px"></i>}
                                            text={"Tambah KSU"}
                                        />
                                    </FlexView>
                            }
                            <SimpleDataTable
                                key={`${this.state.pagination.totalData}-${this.state.pagination.page}`}
                                data={this.state.dataTable}
                                columns={this.state.tableConfig}
                                toCount={this.state.pagination.totalData}
                                rowsPerPage={this.state.pagination.limit}
                                page={this.state.pagination.page - 1}
                                options={{...this.withQrTableOptions, serverSide: false}}
                            />
                            <br/>
                            <FlexView style={{justifyContent: "space-between"}}>
                                <SimpleButton
                                    // secondary
                                    className="margin-left-none margin-top-10px"
                                    text={"Print QR"}
                                    onClick={() => this.handlePreviewQrVisibility("generate")}
                                />

                                {
                                    this.state.activityRead ?
                                        <FlexView vAlignContent="center">
                                            {this.props.userAccess && this.props.userAccess.updateAccess && (
                                                <SimpleButton
                                                    type="button"
                                                    text="Koreksi"
                                                    // secondary
                                                    onClick={() => this.handleCorrection("correction")}
                                                />
                                            )}

                                            {this.props.userAccess && this.props.userAccess.deleteAccess && this.state.isCanDelete && (
                                                <SimpleButton
                                                    type="button"
                                                    text="Hapus"
                                                    // secondary
                                                    onClick={this.handleModalDeleteVisibility}
                                                />
                                            )}

                                            <SimpleButton
                                                type="button"
                                                text="Keluar"
                                                onClick={() => this.props.onClickClose()}
                                            />
                                        </FlexView>
                                        :
                                        <FlexView vAlignContent="center">
                                            <SimpleButton
                                                type="button"
                                                text="Clear"
                                                // secondary
                                                onClick={this.handleClear}
                                            />
                                            <SimpleButton
                                                type="button"
                                                text="Simpan"
                                                // secondary
                                                onClick={this.handleSubmitCheck}
                                            />
                                            <SimpleButton
                                                type="button"
                                                text="Batal"
                                                onClick={() => this.handleCorrection("cancel_correction")}
                                            />
                                        </FlexView>
                                }
                            </FlexView>
                        </ModalContainer>
                    }
                />

                {this.state.warningModalVisible && (
                    <SimpleAlert
                        title={"Information"}
                        content={
                            <div>
                                <p>
                                    Ada field data yang perlu diisi atau tidak sesuai kriteria isian.
                                </p>
                                <br/>
                                <p>
                                    Mohon periksa kembali.
                                </p>
                            </div>
                        }
                        visible={this.state.warningModalVisible}
                        onClickClose={this.handleWarningModalVisibility}
                        additionalButtons={
                            <SimpleButton
                                type="button"
                                text="OK"
                                onClick={() => this.handleWarningModalVisibility()}
                            />
                        }
                    />
                )}

                {this.state.submitCorrectionModalVisible && (
                    <SimpleAlert
                        title={"Information"}
                        content={
                            <div>
                                <p>
                                    Perubahan jumlah akan men-generate QR Code Item baru.
                                </p>
                                <p>
                                    Apakah Anda yakin mau merubah nilai jumlah di tabel ini?
                                </p>
                            </div>
                        }
                        visible={this.state.submitCorrectionModalVisible}
                        onClickClose={this.handleSubmitCorrectionModalVisibility}
                        additionalButtons={
                            <FlexView style={{gap: "15px"}}>
                                <SimpleButton
                                    className="margin-left-none"
                                    type="button"
                                    text="Batal"
                                    onClick={() => this.handleSubmitCorrectionModalVisibility()}
                                />
                                <SimpleButton
                                    secondary
                                    className="margin-left-none"
                                    type="button"
                                    text="Iya"
                                    onClick={() => this.handleSubmit()}
                                />
                            </FlexView>
                        }
                    />
                )}

                {this.state.deleteModalVisible && (
                    <SimpleAlert
                        title={"Warning!"}
                        content={"Apakah Anda Yakin?"}
                        visible={this.state.deleteModalVisible}
                        onClickClose={this.handleModalDeleteVisibility}
                        onSubmit={this.handleSubmitDelete}
                        additionalButtons={
                            <FlexView style={{gap: "15px"}}>
                                <SimpleButton
                                    className="margin-left-none"
                                    type="button"
                                    text="Batal"
                                    onClick={() => this.handleModalDeleteVisibility()}
                                />
                                <SimpleButton
                                    secondary
                                    className="margin-left-none"
                                    type="button"
                                    text="Iya"
                                    onClick={() => this.handleSubmitDelete()}
                                />
                            </FlexView>
                        }
                    />
                )}

                <SimpleLoadingOverlay active={this.state.loading}/>

                {this.state.previewQrVisible && (
                    <InventoryPreviewQR
                        PDF={this.state.PDF}
                        visible={this.state.previewQrVisible}
                        onPreviewQr={() => this.handlePreviewQrVisibility("close")}
                        onStateChange={this.handleStateChange}
                    />
                )}
                {this.state.warningAlert.visible && (
                    <SimpleAlert
                      title={this.state.warningAlert.title}
                      visible={this.state.warningAlert.visible}
                      onClickClose={() => this.handleWarningAlertVisibility()}
                      content={
                        <div>
                                <p>
                                    {this.state.warningAlert.content}
                                </p>
                            </div>
                      }
                      additionalButtons={
                        <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                          <SimpleButton
                            onClick={() => this.handleWarningAlertVisibility()}
                          >
                            OK
                          </SimpleButton>
                        </FlexView>
                      }
                    />
                )}
                {this.renderAlertApproval()}
            </>
        );
    }
}

export default withFormGroup(InventoryDetail);